export default __webpack_public_path__ + "static/media/Soulthief.40b74626.jpg";